// Utility function to combine classes
export const cn = (...classes) => classes.filter(Boolean).join(" ");
